import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useAdmin } from '../context/AdminContext';
import { Percent, Monitor, MapPin, Palette, FileText, Layers } from 'lucide-react';

const Services = () => {
  const { language } = useLanguage();
  const { isEditMode } = useAdmin();

  const content = {
    ru: {
      header: {
        title: 'Наш сервис 360°',
        subtitle: 'Полный цикл от консультации до технической поддержки'
      },
      services: [
        {
          icon: Percent,
          title: 'Гибкие скидки',
          description: 'Индивидуальный подход к каждому клиенту'
        },
        {
          icon: Monitor,
          title: 'Бесплатный шеф-монтаж',
          description: 'Профессиональный надзор за монтажными работами'
        },
        {
          icon: MapPin,
          title: 'Выезд на объект',
          description: 'Консультация и замеры на месте'
        },
        {
          icon: Palette,
          title: 'Дизайнерские решения',
          description: 'Помощь в выборе цветов и текстур'
        },
        {
          icon: FileText,
          title: 'Собственное производство',
          description: 'Полный цикл производства в СЭЗ Астана'
        },
        {
          icon: Layers,
          title: 'Отдел дизайна',
          description: 'Собственное проектное бюро'
        }
      ],
      process: {
        title: 'Процесс работы',
        subtitle: 'От первого контакта до завершения проекта',
        steps: [
          {
            num: '01',
            title: 'Консультация',
            description: 'Выезд на объект, замеры, обсуждение требований'
          },
          {
            num: '02',
            title: 'Проектирование',
            description: 'Разработка дизайн-проекта и спецификаций'
          },
          {
            num: '03',
            title: 'Производство',
            description: 'Изготовление панелей на собственном заводе'
          },
          {
            num: '04',
            title: 'Логистика',
            description: 'Доставка на объект в удобное время'
          },
          {
            num: '05',
            title: 'Монтаж',
            description: 'Профессиональная установка панелей'
          },
          {
            num: '06',
            title: 'Поддержка',
            description: 'Гарантийное и послегарантийное обслуживание'
          }
        ]
      },
      benefits: {
        title: 'Почему выбирают панели GIPSOVINIL.KZ?',
        items: [
          { value: 'в 5 раз', label: 'быстрее традиционной отделки' },
          { value: '100%', label: 'сухой монтаж без мокрых работ' },
          { value: '15+', label: 'лет эксплуатации' }
        ]
      }
    },
    kz: {
      header: {
        title: 'Біздің сервис 360°',
        subtitle: 'Кеңестен техникалық қолдауға дейінгі толық цикл'
      },
      services: [
        {
          icon: Percent,
          title: 'Икемді жеңілдіктер',
          description: 'Әр клиентке жеке көзқарас'
        },
        {
          icon: Monitor,
          title: 'Тегін шеф-монтаж',
          description: 'Монтаж жұмыстарына кәсіби қадағалау'
        },
        {
          icon: MapPin,
          title: 'Объектіге шығу',
          description: 'Орнында кеңес беру және өлшеу'
        },
        {
          icon: Palette,
          title: 'Дизайнерлік шешімдер',
          description: 'Түстер мен текстураларды таңдауға көмек'
        },
        {
          icon: FileText,
          title: 'Өз өндірісі',
          description: 'Астана АЭА-да толық өндіріс циклі'
        },
        {
          icon: Layers,
          title: 'Дизайн бөлімі',
          description: 'Жеке жобалау бюросы'
        }
      ],
      process: {
        title: 'Жұмыс процесі',
        subtitle: 'Алғашқы байланыстан жоба аяқталғанға дейін',
        steps: [
          {
            num: '01',
            title: 'Кеңес беру',
            description: 'Объектіге шығу, өлшеу, талаптарды талқылау'
          },
          {
            num: '02',
            title: 'Жобалау',
            description: 'Дизайн-жоба және спецификацияларды әзірлеу'
          },
          {
            num: '03',
            title: 'Өндіріс',
            description: 'Жеке зауытта панельдер жасау'
          },
          {
            num: '04',
            title: 'Логистика',
            description: 'Ыңғайлы уақытта объектіге жеткізу'
          },
          {
            num: '05',
            title: 'Монтаж',
            description: 'Панельдерді кәсіби орнату'
          },
          {
            num: '06',
            title: 'Қолдау',
            description: 'Кепілдік және кепілдіктен кейінгі қызмет'
          }
        ]
      },
      benefits: {
        title: 'Неліктен GIPSOVINIL.KZ панельдерін таңдайды?',
        items: [
          { value: '5x', label: 'дәстүрлі әрлеуден жылдам' },
          { value: '100%', label: 'ылғалсыз құрғақ монтаж' },
          { value: '15+', label: 'жыл пайдалану' }
        ]
      }
    },
    en: {
      header: {
        title: 'Our 360° Service',
        subtitle: 'Full cycle from consultation to technical support'
      },
      services: [
        {
          icon: Percent,
          title: 'Flexible Discounts',
          description: 'Individual approach to each client'
        },
        {
          icon: Monitor,
          title: 'Free Installation Supervision',
          description: 'Professional oversight of installation works'
        },
        {
          icon: MapPin,
          title: 'Site Visit',
          description: 'On-site consultation and measurements'
        },
        {
          icon: Palette,
          title: 'Design Solutions',
          description: 'Help with color and texture selection'
        },
        {
          icon: FileText,
          title: 'Own Production',
          description: 'Full production cycle in Astana SEZ'
        },
        {
          icon: Layers,
          title: 'Design Department',
          description: 'In-house design bureau'
        }
      ],
      process: {
        title: 'Work Process',
        subtitle: 'From first contact to project completion',
        steps: [
          {
            num: '01',
            title: 'Consultation',
            description: 'Site visit, measurements, requirements discussion'
          },
          {
            num: '02',
            title: 'Design',
            description: 'Development of design project and specifications'
          },
          {
            num: '03',
            title: 'Production',
            description: 'Panel manufacturing at our own factory'
          },
          {
            num: '04',
            title: 'Logistics',
            description: 'Delivery to site at convenient time'
          },
          {
            num: '05',
            title: 'Installation',
            description: 'Professional panel installation'
          },
          {
            num: '06',
            title: 'Support',
            description: 'Warranty and post-warranty service'
          }
        ]
      },
      benefits: {
        title: 'Why Choose GIPSOVINIL.KZ Panels?',
        items: [
          { value: '5x', label: 'faster than traditional finishing' },
          { value: '100%', label: 'dry installation without wet work' },
          { value: '15+', label: 'years of operation' }
        ]
      }
    },
    ar: {
      header: {
        title: 'خدمتنا الشاملة 360°',
        subtitle: 'دورة متكاملة من الاستشارة إلى الدعم الفني'
      },
      services: [
        {
          icon: Percent,
          title: 'خصومات مرنة',
          description: 'نهج فردي مع كل عميل'
        },
        {
          icon: Monitor,
          title: 'إشراف مجاني على التركيب',
          description: 'إشراف متخصص على أعمال التركيب'
        },
        {
          icon: MapPin,
          title: 'زيارة الموقع',
          description: 'استشارة ميدانية وأخذ القياسات'
        },
        {
          icon: Palette,
          title: 'حلول تصميمية',
          description: 'المساعدة في اختيار الألوان والأنسجة'
        },
        {
          icon: FileText,
          title: 'إنتاج خاص',
          description: 'دورة إنتاج متكاملة في المنطقة الاقتصادية الخاصة بأستانا'
        },
        {
          icon: Layers,
          title: 'قسم التصميم',
          description: 'مكتب تصميم داخلي متخصص'
        }
      ],
      process: {
        title: 'مراحل العمل',
        subtitle: 'من أول تواصل حتى اكتمال المشروع',
        steps: [
          {
            num: '01',
            title: 'الاستشارة',
            description: 'زيارة الموقع، أخذ القياسات، مناقشة المتطلبات'
          },
          {
            num: '02',
            title: 'التصميم',
            description: 'إعداد مشروع التصميم والمواصفات التقنية'
          },
          {
            num: '03',
            title: 'الإنتاج',
            description: 'تصنيع الألواح في مصنعنا الخاص'
          },
          {
            num: '04',
            title: 'اللوجستيات',
            description: 'التوصيل إلى الموقع في الوقت المناسب'
          },
          {
            num: '05',
            title: 'التركيب',
            description: 'تركيب احترافي للألواح'
          },
          {
            num: '06',
            title: 'الدعم',
            description: 'خدمة ما بعد البيع وضمان الجودة'
          }
        ]
      },
      benefits: {
        title: 'لماذا تختار ألواح GIPSOVINIL.KZ؟',
        items: [
          { value: '5x', label: 'أسرع من التشطيب التقليدي' },
          { value: '100%', label: 'تركيب جاف دون أعمال رطبة' },
          { value: '15+', label: 'سنة من الخبرة التشغيلية' }
        ]
      }
    }
  };

  const t = content[language] || content.en || content.ru;

  return (
    <div data-testid="services-section" className={`relative ${isEditMode ? 'ring-2 ring-blue-400 ring-inset' : ''}`}>
      {isEditMode && (
        <div className="absolute top-2 left-2 bg-blue-500 text-white text-xs px-2 py-1 rounded z-10">
          Секция: Сервис 360°
        </div>
      )}
      
      {/* Benefits Section - Почему выбирают панели */}
      <section className="pt-6 py-2 pb-6 bg-[#061d36]">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8">{t.benefits.title}</h2>
          
          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            {t.benefits.items.map((item, index) => (
              <div
                key={index}
                data-testid={`benefit-${index}`}
                className="bg-[#1a3a5c] rounded-2xl p-6 text-center"
              >
                <div className="text-4xl md:text-5xl font-bold text-white mb-2">{item.value}</div>
                <p className="text-white text-sm">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Header - Наш сервис 360 */}
      <section className="pt-6 py-2 pb-6 bg-[#061d36] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-testid="services-title">{t.header.title}</h2>
          <p className="text-lg text-white/80 max-w-3xl mx-auto">{t.header.subtitle}</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="pt-6 py-2 pb-6 bg-[#061d36]">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {t.services.map((service, index) => {
              const IconComponent = service.icon;
              return (
                <div
                  key={index}
                  data-testid={`service-card-${index}`}
                  className="bg-[#1a3a5c] rounded-2xl p-6 hover:bg-[#1f4a6e] transition-colors"
                >
                  <div className="w-12 h-12 bg-[#8b4444] rounded-xl flex items-center justify-center mb-4">
                    <IconComponent className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{service.title}</h3>
                  <p className="text-white/70">{service.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
